import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../App.css";

import slider1 from '../assets/slider1.jpeg';
import slider2 from '../assets/slider2.jpeg';
import mobility from '../assets/mobility.jpeg';

const VerticalSwiper = () => {
  const images = [slider1, slider2, mobility, slider1, slider2, mobility];

  return (
   <div className="swiper-bg-container">
        <Swiper
          modules={[Autoplay]}
          direction="vertical"
          slidesPerView={3}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          className="verticalImageSwiper"
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="slide-overlay-wrapper">
                <img src={img} alt={`Slide ${index + 1}`} className="vertical-image" />
                <div className="side-dark-overlay"></div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

export default VerticalSwiper;
